export class AppConfig {
    public static HOST_URL = process.env.REACT_APP_HOST_URL || 'demo.vyaparlive.com';
    public static BASE_URL = process.env.REACT_APP_BASE_URL || 'https://demo.vyaparlive.com';
    // public static BASE_URL ="http://localhost:4051";
    public static HTTP_PORT = '';
    public static ORGANIZATION_PORT = '';
    public static INVITATION_PORT = '';
    public static PRODUCTS_PORT = '';
    public static RETAIL_PORT = '';
}